import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import CourseCard from '../../../components/Cours/CourseCard';
import coursesService from '../../../services/coursesService';

const courses = [
   {
      id: 1,
      title: "Learn Figma - UI/UX Design Essential Training",
      image: "/coursesCards/1.png",
      rating: 4.5,
      reviews: 1991,
      lessons: 6,
      duration: "3h 56m",
      level: "Beginner",
      author: "Ali Tufan",
      authorAvatar: "/general/avatar-1.png",
      originalPrice: 179,
      discountedPrice: 79,
      tags: []
   },
   {
      id: 2,
      title: "Complete Python Bootcamp From Zero to Hero in Python",
      image: "/coursesCards/2.png",
      rating: 4.5,
      reviews: 1991,
      lessons: 6,
      duration: "3h 56m",
      level: "Beginner",
      author: "Ali Tufan",
      authorAvatar: "/general/avatar-1.png",
      originalPrice: 179,
      discountedPrice: 79,
      tags: ["POPULAR", "BEST SELLERS"]
   },
   {
      id: 3,
      title: "Angular - The Complete Guide (2022 Edition)",
      image: "/coursesCards/2.png",
      rating: 4.5,
      reviews: 1991,
      lessons: 6,
      duration: "3h 56m",
      level: "Beginner",
      author: "Ali Tufan",
      authorAvatar: "/general/avatar-1.png",
      originalPrice: 179,
      discountedPrice: 79,
      tags: []
   },
   {
      id: 4,
      title: "The Ultimate Drawing Course Beginner to Advanced",
      image: "/coursesCards/2.png",
      rating: 4.5,
      reviews: 1991,
      lessons: 6,
      duration: "3h 56m",
      level: "Beginner",
      author: "Ali Tufan",
      authorAvatar: "/general/avatar-1.png",
      originalPrice: 179,
      discountedPrice: 79,
      tags: []
   },
   {
      id: 5,
      title: "Photography Masterclass: A Complete Guide to Photography",
      image: "/coursesCards/2.png",
      rating: 4.5,
      reviews: 1991,
      lessons: 6,
      duration: "3h 56m",
      level: "Beginner",
      author: "Ali Tufan",
      authorAvatar: "/general/avatar-1.png",
      originalPrice: 179,
      discountedPrice: 79,
      tags: []
   },
   {
      id: 6,
      title: "Instagram Marketing 2021: Complete Guide To Instagram",
      image: "/coursesCards/2.png",
      rating: 4.5,
      reviews: 1991,
      lessons: 6,
      duration: "3h 56m",
      level: "Beginner",
      author: "Ali Tufan",
      authorAvatar: "/general/avatar-1.png",
      originalPrice: 179,
      discountedPrice: 79,
      tags: []
   },
   {
      id: 7,
      title: "Complete Blender Creator: Learn 3D Modelling for Beginners",
      image: "/coursesCards/2.png",
      rating: 4.5,
      reviews: 1991,
      lessons: 6,
      duration: "3h 56m",
      level: "Beginner",
      author: "Ali Tufan",
      authorAvatar: "/general/avatar-1.png",
      originalPrice: 179,
      discountedPrice: 79,
      tags: []
   },
   {
      id: 8,
      title: "The Complete Financial Analyst Training &amp; Investing Course",
      image: "/coursesCards/2.png",
      rating: 4.5,
      reviews: 1991,
      lessons: 6,
      duration: "3h 56m",
      level: "Beginner",
      author: "Ali Tufan",
      authorAvatar: "/general/avatar-1.png",
      originalPrice: 179,
      discountedPrice: 79,
      tags: []
   },
];

function Carousel({ courseCurrent }) {
   const carouselRef = useRef(null);
   const [currentIndex, setCurrentIndex] = useState(0);
   const [courses, setCourses] = useState([]);
   const [filteredCourses, setFilteredCourses] = useState([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   const navigate = useNavigate();

   const fetchCourses = useCallback(async () => {
      setLoading(true);
      setError(null);
      try {
         const response = await coursesService.getAllCourses();
         const list = Array.isArray(response) ? response : (response?.data ?? []);
         setCourses(list);
         if (courseCurrent?.category_id) {
            const filtered = list.filter(
               (c) => c.category_id === courseCurrent.category_id && c.id !== courseCurrent.id
            );
            setFilteredCourses(filtered);
         } else {
            setFilteredCourses(list);
         }
      } catch (err) {
         setError('Erreur de connexion au serveur');
         console.error('Erreur:', err);
      } finally {
         setLoading(false);
      }
   }, [courseCurrent]);

   useEffect(() => {
      fetchCourses();
   }, [fetchCourses]);

   if (loading) {
      return (
         <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
         </div>
      );
   }

   if (error) {
      return (
         <section className="pb-16 dark:border-b dark:border-light-2">
            <div className="container mx-auto px-4">
               <div className="text-center py-12 text-red-500">{error}</div>
            </div>
         </section>
      );
   }

   const handleCourseClick = (courseId) => {
      navigate(`/courses-single/${courseId}`);
   };

   const getVisibleCardsCount = () => {
      if (typeof window === 'undefined') return 4;
      if (window.innerWidth >= 1280) return 4; // xl
      if (window.innerWidth >= 1024) return 3; // lg
      if (window.innerWidth >= 640) return 2;  // sm
      return 1;
   };

   const visibleCards = getVisibleCardsCount();

   const scrollToIndex = (index) => {
      if (!carouselRef.current) return;

      const cardWidth = carouselRef.current.children[0]?.offsetWidth || 0;
      const gap = 24;
      const scrollPosition = index * (cardWidth + gap);

      carouselRef.current.scrollTo({
         left: scrollPosition,
         behavior: 'smooth'
      });

      setCurrentIndex(index);
   };

   const scrollPrev = () => {
      const newIndex = Math.max(0, currentIndex - 1);
      scrollToIndex(newIndex);
   };

   const scrollNext = () => {
      const maxIndex = Math.max(0, courses.length - visibleCards);
      const newIndex = Math.min(maxIndex, currentIndex + 1);
      scrollToIndex(newIndex);
   };

   return (
      <section>
         <div className="flex flex-col md:flex-row justify-between items-end gap-6 mb-8">
            <div className="text-center md:text-left">
               <h2 className="text-3xl font-bold text-dark-1 mb-2 dark:text-white">You May Like</h2>
               <p className="text-gray-600 dark:text-gray-400">10,000+ unique online course list designs</p>
            </div>
         </div>

         <div className="relative">
            <div
               ref={carouselRef}
               className="flex overflow-x-hidden gap-6 scroll-smooth py-2"
               style={{ scrollbarWidth: 'none' }}
            >
               {filteredCourses.map((course, index) => (
                  <div
                     key={course.id}
                     className="flex-none"
                     style={{
                        width: `calc((100% - ${(visibleCards - 1) * 24}px) / ${visibleCards})`,
                        minWidth: '280px' // Ajout d'une largeur minimale pour les petits écrans
                     }}
                  >
                     <CourseCard course={course} animationDelay={index + 1} onClick={() => handleCourseClick(course.id)} />
                  </div>
               ))}
            </div>

            {/* Boutons de navigation */}
            {currentIndex > 0 && (
               <button
                  onClick={scrollPrev}
                  className="absolute left-2 sm:left-4 top-[44%] transform -translate-y-1/2 bg-white dark:bg-dark-5 
               text-dark-1 dark:text-white w-12 h-12 sm:w-16 sm:h-16 rounded-full shadow-lg flex items-center 
               justify-center hover:bg-purple-1 hover:text-white transition-colors
               focus:outline-none focus:ring-2 focus:ring-purple-1 dark:focus:ring-purple-300"
                  aria-label="Previous slide"
               >
                  <FontAwesomeIcon
                     icon={faArrowLeft}
                     className="text-lg sm:text-xl"
                  />
               </button>
            )}

            {currentIndex < courses.length - visibleCards && (
               <button
                  onClick={scrollNext}
                  className="absolute right-2 sm:right-4 top-[44%] transform -translate-y-1/2 bg-white dark:bg-dark-5 
                text-dark-1 dark:text-white w-12 h-12 sm:w-16 sm:h-16 rounded-full shadow-lg flex items-center 
                justify-center hover:bg-purple-1 hover:text-white transition-colors
                focus:outline-none focus:ring-2 focus:ring-purple-1 dark:focus:ring-purple-300"
                  aria-label="Next slide"
               >
                  <FontAwesomeIcon
                     icon={faArrowRight}
                     className="text-lg sm:text-xl"
                  />
               </button>
            )}
         </div>
      </section>
   )
}

export default Carousel